export default "__VITE_ASSET__D5Xi6h3r__"